// Copyright 2017 Sorama B.V.

import { ActivatedLicenseDTO, LicenseDTO, SellableLicense } from "datatypes/SoramaWebApi";

export abstract class ILicenseService {
    readonly activeMembershipLicense: LicenseDTO;
    readonly activeMembershipLicenseLoaded: boolean;
    public abstract getActiveMembershipLicense(): Promise<LicenseDTO>;
    public abstract getActivatedLicensesForDevice(deviceId: string): Promise<ActivatedLicenseDTO[]>;
    readonly sellableFeatureLicenses: SellableLicense[];
    public abstract reloadSellableFeatureLicenses(): void;
    public abstract activateFeature(licenseId: string, deviceId: string, hardwareClock: number): Promise<string>;
    public abstract encryptLicense(licenseId: string, deviceId: string, hardwareClock: number): Promise<string>;
    public abstract restoreFeatureLicenses(deviceId: string, hardwareClock: number): Promise<string[]>;
}
